import http from '../http'

export default {
    /**
     * Create a new pregunta.
     * @param {int} examen 
     * @param {Object} pregunta 
     * @returns {Promise}
     */
    add(examen, pregunta) {
        return http.post(`examenes/${examen}/preguntas`, pregunta)
    },

    /**
     * Update a pregunta.
     * @param {int} examen 
     * @param {int} pregunta 
     * @param {Object} payload 
     * @returns {Promise}
     */
    update(examen, pregunta, payload) {
        return http.put(`examenes/${examen}/preguntas/${pregunta}`, payload)
    },

    /**
     * Delete a pregunta.
     * @param {int} examen 
     * @param {int} pregunta 
     * @returns {Promise}
     */
    delete(examen, pregunta) {
        return http.delete(`examenes/${examen}/preguntas/${pregunta}`)
    }
}